import Vue from 'vue'

export default {
  AUTO_COMPLETE_ADDRESS(state, { bairro, cep, localidade, logradouro, uf}) {
    const region = state.ufs.filter(item => item.uf == uf)[0]
    const cepNumber = parseInt(cep.replace(/-/g, ''), 10)
    const address = Object.assign({}, state.address, {
      city: localidade,
      state: region.uf,
      address: logradouro,
      postalcode: cepNumber,
      address_neighborhood: bairro,
      autocomplete: !state.address.autocomplete
    })
    Vue.set(state, 'address', address)
  },
  UPDATE_FIELD: (state, { field, value }) => state.address[field] = value,

  SET_ADDRESS: (state, payload) => state.address = Object.assign({}, state.address, {...payload}, { country: 'Brasil' }),

  PARSE_ADDRESS: (state, payload) => state.address = Object.assign({}, state.address, {...payload}),

  CLEAR_ADDRESS_STATE: (state) => state.address = {
    state: '',
    postalcode: '',
    country: 'Brasil',
    address_number: '',
    address_neighborhood: '',
    address: '',
    city: '',
    address_complement: '',
    autocomplete: false
  },

  store: (state, payload) => state.address = Object.assign({}, { ...payload }),
}